<template>
  <div class="wrapper">
    <app-main/>
  </div>
</template>

<script>
import { AppMain } from './components'

export default {
  name: 'Layout',
  components: {
    AppMain
  },
  mixins: [],
  computed: {

  },
  methods: {

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  // @import "src/styles/reset.scss";
  // @import "src/styles/class.scss";
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue